<template>
	<div class="service">
    <v-app id="service">
      <v-content v-if="item">
        <v-carousel 
          hide-delimiters 
          show-arrows-on-hover 
          cycle 
          v-if="extendy"
          height="400"
          class="hidden-sm-and-down">
          <v-carousel-item 
            :src="getFirstImage(item.carousel_images)"
            v-if="getFirstImage(item.carousel_images)">
          </v-carousel-item>
          <v-carousel-item 
            :src="getSecondImage(item.carousel_images)"
            v-if="getSecondImage(item.carousel_images)">
          </v-carousel-item>
          <v-carousel-item 
            :src="getThirdImage(item.carousel_images)"
            v-if="getThirdImage(item.carousel_images)">
          </v-carousel-item>
          <v-carousel-item 
            :src="getFourthImage(item.carousel_images)"
            v-if="getFourthImage(item.carousel_images)">
          </v-carousel-item>
          <v-carousel-item 
            :src="getFifthImage(item.carousel_images)"
            v-if="getFifthImage(item.carousel_images)">
          </v-carousel-item>
          <span class="mapit">
            <mapdirection/>
            <v-bottom-sheet v-model="sheet1" inset>
              <template v-slot:activator="{ on }">
                <v-btn fab small rounded color="grey lighten-1" 
                  style="left: 85px; position: relative; bottom: 2px;" 
                  v-on="on">
                  <v-icon>
                    mdi-share-variant
                  </v-icon>
                </v-btn>
              </template>
              <v-sheet class="text-center" height="100px">
                <div class="label"><b>Share This Service:</b></div>
                  <social-sharing :url="'https://vergeo-21ffc.firebaseapp.com/service'+ item.slug" :title="item.name" :description="item.description" quote="This Service is from Convergeo click here to view.." hashtags="convergeo services" twitter-user="Convergeo" inline-template>
                    <div>
                      <network network="facebook">
                        <a href="#"><img src="@/assets/facebook.jpg" alt="Facebook" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                      </network>
                      <network network="linkedin">
                        <a href="#"><img src="@/assets/linkedIn.png" alt="linkedin" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                      </network>
                      <network network="pinterest">
                        <a href="#"><img src="@/assets/pinterest.jpg" alt="pinterest" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                      </network>
                      <network network="skype">
                        <a href="#"><img src="@/assets/skype.jpg" alt="skype" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                      </network>
                      <network network="twitter">
                        <a href="#"><img src="@/assets/twitter.jpg" alt="Twitter" width="30" /> <v-divider class="mx-4" vertical></v-divider></a>
                      </network>
                      <network network="whatsapp">
                        <a href="#"><img src="@/assets/whatsapp.jpg" alt="whatsapp" width="30" /></a>
                      </network> 
                    </div>
                  </social-sharing>
              </v-sheet>
            </v-bottom-sheet>
          </span>
          <v-card-title class="align-end fill-height white--text ml-10 main-title">
            <b class="main-title-text">
            {{ item.name | uppercase }}
           </b>
          </v-card-title>
          <v-card-title class="align-end fill-height white--text ml-10 title">
              <b class="title-text"><i>{{ item.carousel_text }}</i></b>
          </v-card-title>
          <v-card-title class="align-end fill-height white--text crumb">
            <router-link to="/">Home</router-link>
            <v-icon>mdi-forward</v-icon>
            <router-link :to="'/services/'+ item.Cat_slug">
              {{ item.Cat_slug | capitalize}}
            </router-link>
            <v-icon>mdi-forward</v-icon>
            {{  item.name | capitalize }}
          </v-card-title>
        </v-carousel>
        <v-carousel 
          hide-delimiters 
          show-arrows-on-hover 
          cycle 
          v-else
          height="200"
          class="hidden-sm-and-down">
          <v-carousel-item 
            :src="getFirstImage(item.carousel_images)"
            v-if="getFirstImage(item.carousel_images)">
          </v-carousel-item>
          <v-card-title class="align-end fill-height white--text ml-10 main-title">
            <b class="main-title-text">
            {{ item.name | uppercase }}
           </b>
          </v-card-title>
          <v-card-title class="align-end fill-height white--text ml-10 title">
              <b class="title-text"><i>{{ item.carousel_text }}</i></b>
          </v-card-title>
          <v-card-title class="align-end fill-height white--text crumb">
            <router-link to="/">Home</router-link>
            <v-icon>mdi-forward</v-icon>
            <router-link :to="'/services/'+ item.Cat_slug">
              {{ item.Cat_slug | capitalize}}
            </router-link>
            <v-icon>mdi-forward</v-icon>
            {{  item.name | capitalize }}
          </v-card-title>
        </v-carousel>
        <v-carousel 
          hide-delimiters 
          show-arrows-on-hover 
          cycle 
          height="210" 
          class="hidden-md-and-up">
          <v-carousel-item 
            :src="getFirstImage(item.carousel_images)"
            v-if="getFirstImage(item.carousel_images)">
          </v-carousel-item>
          <v-carousel-item 
            :src="getSecondImage(item.carousel_images)"
            v-if="getSecondImage(item.carousel_images)">
          </v-carousel-item>
          <v-carousel-item 
            :src="getThirdImage(item.carousel_images)"
            v-if="getThirdImage(item.carousel_images)">
          </v-carousel-item>
          <v-carousel-item 
            :src="getFourthImage(item.carousel_images)"
            v-if="getFourthImage(item.carousel_images)">
          </v-carousel-item>
          <v-carousel-item 
            :src="getFifthImage(item.carousel_images)"
            v-if="getFifthImage(item.carousel_images)">
          </v-carousel-item>
          <span class="mapit-mobile">
            <mapdirection/>
            <v-bottom-sheet v-model="sheet" inset>
              <template v-slot:activator="{ on }">
                <v-btn fab small rounded color="grey lighten-1" 
                  style="left: 85px; position: relative; bottom: 2px;" 
                  v-on="on">
                  <v-icon>
                    mdi-share-variant
                  </v-icon>
                </v-btn>
              </template>
              <v-sheet class="text-center" height="80px">
                <div class="label"><b>Share This Service:</b></div>
                  <social-sharing :url="'https://vergeo-21ffc.firebaseapp.com/service'+ item.slug" :title="item.name" :description="item.description" quote="This Service is from Convergeo click here to view.." hashtags="convergeo services" twitter-user="Convergeo" inline-template>
                  <div>
                    <network network="facebook">
                      <a href="#"><img src="@/assets/facebook.jpg" alt="Facebook" width="30" /> <v-divider class="mx-2" vertical></v-divider></a>
                    </network>
                    <network network="linkedin">
                      <a href="#"><img src="@/assets/linkedIn.png" alt="linkedin" width="30" /> <v-divider class="mx-2" vertical></v-divider></a>
                    </network>
                    <network network="pinterest">
                      <a href="#"><img src="@/assets/pinterest.jpg" alt="pinterest" width="30" /> <v-divider class="mx-2" vertical></v-divider></a>
                    </network>
                    <network network="skype">
                      <a href="#"><img src="@/assets/skype.jpg" alt="skype" width="30" /> <v-divider class="mx-2" vertical></v-divider></a>
                    </network>
                    <network network="twitter">
                      <a href="#"><img src="@/assets/twitter.jpg" alt="Twitter" width="30" /> <v-divider class="mx-2" vertical></v-divider></a>
                    </network>
                    <network network="whatsapp">
                      <a href="#"><img src="@/assets/whatsapp.jpg" alt="whatsapp" width="30" /></a>
                    </network> 
                  </div>
                </social-sharing>
              </v-sheet>
            </v-bottom-sheet>
          </span>
          <v-card-title class="align-end fill-height white--text ml-10 main-title-mobile">
            <b class="main-title-text-mobile">{{ item.name | uppercase }}</b>
          </v-card-title>
          <v-card-title class="align-end fill-height white--text ml-10 title-mobile">
              <b class="title-text-mobile"><i>{{ item.carousel_text }}</i></b>
          </v-card-title>
          <v-card-title class="align-end fill-height white--text crumb-mobile">
            <router-link to="/">Home</router-link>
            <v-icon small style="margin-bottom: 7px">mdi-forward</v-icon>
            <router-link :to="'/services/'+ item.Cat_slug">
              {{ item.Cat_slug | capitalize}}
            </router-link>
          </v-card-title>
        </v-carousel>
        <v-tabs dark background-color="indigo lighten-4" show-arrows>
          <b class="hidden-sm-and-down" v-if="extendy" @click="open_viewer">
            <v-icon color="grey darken-3" style="margin-top: 10px; ">
              mdi-arrow-down-drop-circle
            </v-icon>
          </b>
          <b class="hidden-sm-and-down" v-else @click="close_viewer">
            <v-icon color="grey darken-3" style="margin-top: 10px; ">
              mdi-arrow-up-drop-circle
            </v-icon>
          </b>
        <!-- <swimming pool + conference room in carousel with view all> -->
          <v-tabs-slider color="black"></v-tabs-slider>
          <v-tab 
            v-if="
              (item.SubCat_slug == 'hotels') ||
              (item.SubCat_slug == 'lodges') ||
              (item.SubCat_slug == 'buffets') ||
              (item.SubCat_slug == 'restaurants') ||
              (item.SubCat_slug == 'take-aways') ||
              (item.SubCat_slug == 'guest-houses-cottages')">
            <b class="label" @click="open_viewer">Restaurant</b>
          </v-tab>
          <v-tab 
            v-if="
              (item.SubCat_slug == 'apartments') || 
              (item.SubCat_slug == 'rental-houses-facilities') || 
              (item.SubCat_slug == 'boarding-houses-hostels')">
            <b class="label" @click="open_viewer">Room View</b>
          </v-tab>
          <v-tab 
            v-if="
              (item.SubCat_slug == 'hotels') ||
              (item.SubCat_slug == 'dance-classes') ||
              (item.SubCat_slug == 'gyms') ||
              (item.SubCat_slug == 'massage-spa-treatments') ||
              (item.SubCat_slug == 'sports-clubs') ||
              (item.SubCat_slug == 'fabric-furniture-repair') ||
              (item.SubCat_slug == 'home-office-construction') ||
              (item.SubCat_slug == 'light-water-repair') ||
              (item.SubCat_slug == 'bureau-of-standards') ||
              (item.SubCat_slug == 'consumer-protection') ||
              (item.SubCat_slug == 'recruitments') ||
              (item.SubCat_slug == 'banks') ||
              (item.SubCat_slug == 'car-fabrics-locomotive-washing') ||
              (item.SubCat_slug == 'dental-dermatology') || 
              (item.SubCat_slug == 'fertility-sonar-pediatrics') ||
              (item.SubCat_slug == 'garbage-collection') ||
              (item.SubCat_slug == 'indoor-window-interior-cleaning') ||
              (item.SubCat_slug == 'pests-rodent-reptile-clearing') ||
              (item.SubCat_slug == 'radiology-xrays') ||
              (item.SubCat_slug == 'vet-clinic') ||
              (item.SubCat_slug == 'taxation-bills') || 
              (item.SubCat_slug == 'bureau-de-change') ||
              (item.SubCat_slug == 'electricity-bills') ||
              (item.SubCat_slug == 'insurance') ||
              (item.SubCat_slug == 'micro-finance-loans') ||
              (item.SubCat_slug == 'tv-pay') ||
              (item.SubCat_slug == 'water-bills') ||
              (item.SubCat_slug == 'security-protection') ||
              (item.SubCat_slug == 'mechanical-repair') ||
              (item.SubCat_slug == 'adventure-spots-camps') || 
              (item.SubCat_slug == 'casinos') ||
              (item.SubCat_slug == 'family-parks') ||
              (item.SubCat_slug == 'game-reserves') ||
              (item.SubCat_slug == 'night-clubs-bars') ||
              (item.SubCat_slug == 'adventure-spots-camps') ||
              (item.SubCat_slug == 'art-print-design') ||
              (item.SubCat_slug == 'computer-telecom') || 
              (item.SubCat_slug == 'legal-aid-advocates') ||
              (item.SubCat_slug == 'metal-plastic-wood') ||
              (item.SubCat_slug == 'intranet-network') ||
              (item.SubCat_slug == 'landline-internet') || 
              (item.SubCat_slug == 'mobile-network') ||
              (item.SubCat_slug == 'events-hosting-venues') || 
              (item.SubCat_slug == 'morgue-send-off-planners') ||
              (item.SubCat_slug == 'flowers-decoration') ||
              (item.SubCat_slug == 'wedding-birthday-party-planners') ||
              (item.SubCat_slug == 'yoga-workouts')">
            <b class="label" @click="open_viewer">Activities</b>
          </v-tab>
          <v-tab 
            v-if="
              (item.SubCat_slug == 'gyms') ||
              (item.SubCat_slug == 'hotels') ||
              (item.SubCat_slug == 'car-fabrics-locomotive-washing') ||
              (item.SubCat_slug == 'dental-dermatology') || 
              (item.SubCat_slug == 'fertility-sonar-pediatrics') ||
              (item.SubCat_slug == 'events-hosting-venues') || 
              (item.SubCat_slug == 'morgue-send-off-planners') ||
              (item.SubCat_slug == 'flowers-decoration') ||
              (item.SubCat_slug == 'wedding-birthday-party-planners') ||
              (item.SubCat_slug == 'garbage-collection') ||
              (item.SubCat_slug == 'indoor-window-interior-cleaning') ||
              (item.SubCat_slug == 'pests-rodent-reptile-clearing') ||
              (item.SubCat_slug == 'radiology-xrays') ||
              (item.SubCat_slug == 'vet-clinic') ||
              (item.SubCat_slug == 'game-reserves') ||
              (item.SubCat_slug == 'art-print-design') || 
              (item.SubCat_slug == 'metal-plastic-wood') ||
              (item.SubCat_slug == 'heritage-archives') ||
              (item.SubCat_slug == 'lodges')">
            <b class="label" @click="open_viewer">Available Items</b>
          </v-tab>
          <v-tab 
            v-if="
              (item.SubCat_slug == 'hotels') ||
              (item.SubCat_slug == 'lodges') ||
              (item.SubCat_slug == 'guest-houses-cottages')">
            <b class="label" @click="open_viewer">Rooms</b>
          </v-tab>
          <v-tab 
            v-if="
              (item.SubCat_slug == 'hotels') ||
              (item.SubCat_slug == 'night-clubs-bars') ||
              (item.SubCat_slug == 'guest-houses-cottages') ||
              (item.SubCat_slug == 'lodges')">
            <b class="label" @click="open_viewer">Drinks</b>
          </v-tab>
          <v-tab 
            v-if="
              (item.SubCat_slug == 'cinemas') ||
              (item.SubCat_slug == 'airline-flight') ||
              (item.SubCat_slug == 'bus-railway') || 
              (item.SubCat_slug == 'cargo-freight') ||
              (item.SubCat_slug == 'taxi') ||
              (item.SubCat_slug == 'warehouse-container-storage') ||
              (item.SubCat_slug == 'hotels')">
            <b class="label" @click="open_viewer">Extra Facilities</b>
          </v-tab>
          <v-tab 
            v-if="
              (item.SubCat_slug == 'hotels') ||
              (item.SubCat_slug == 'lodges')">
            <b class="label" @click="open_viewer">Gym</b>
          </v-tab>
          <v-tab 
            v-if="
              (item.SubCat_slug == 'dental-dermatology') ||
              (item.SubCat_slug == 'fertility-sonar-pediatrics') ||
              (item.SubCat_slug == 'radiology-xrays') ||
              (item.SubCat_slug == 'vet-clinic')">
            <b class="label" @click="open_viewer">Health Procedures</b>
          </v-tab>
          <v-tab 
            v-if="
              (item.SubCat_slug == 'airline-flight') ||
              (item.SubCat_slug == 'bus-railway') || 
              (item.SubCat_slug == 'cargo-freight') ||
              (item.SubCat_slug == 'taxi') ||
              (item.SubCat_slug == 'warehouse-container-storage') ||
              (item.SubCat_slug == 'adventure-spots-camps')">
            <b class="label" @click="open_viewer">Max Cap</b>
          </v-tab>
          <v-tab 
            v-if="
              (item.SubCat_slug == 'dance-classes') ||
              (item.SubCat_slug == 'gyms') ||
              (item.SubCat_slug == 'massage-spa-treatments') ||
              (item.SubCat_slug == 'sports-clubs') ||
              (item.SubCat_slug == 'bureau-of-standards') ||
              (item.SubCat_slug == 'consumer-protection') ||
              (item.SubCat_slug == 'banks') ||
              (item.SubCat_slug == 'taxation-bills') || 
              (item.SubCat_slug == 'electricity-bills') ||
              (item.SubCat_slug == 'insurance') ||
              (item.SubCat_slug == 'micro-finance-loans') ||
              (item.SubCat_slug == 'tv-pay') ||
              (item.SubCat_slug == 'water-bills') ||
              (item.SubCat_slug == 'recruitments') ||
              (item.SubCat_slug == 'car-fabrics-locomotive-washing') ||
              (item.SubCat_slug == 'garbage-collection') ||
              (item.SubCat_slug == 'indoor-window-interior-cleaning') ||
              (item.SubCat_slug == 'pests-rodent-reptile-clearing') ||
              (item.SubCat_slug == 'buffets') ||
              (item.SubCat_slug == 'events-hosting-venues') || 
              (item.SubCat_slug == 'morgue-send-off-planners') ||
              (item.SubCat_slug == 'flowers-decoration') ||
              (item.SubCat_slug == 'wedding-birthday-party-planners') ||
              (item.SubCat_slug == 'security-protection') ||
              (item.SubCat_slug == 'real-estate') ||
              (item.SubCat_slug == 'intranet-network') ||
              (item.SubCat_slug == 'landline-internet') || 
              (item.SubCat_slug == 'mobile-network') ||
              (item.SubCat_slug == 'outdoor-advertising') ||
              (item.SubCat_slug == 'radio-advertising') ||
              (item.SubCat_slug == 'tv-advertising') ||
              (item.SubCat_slug == 'yoga-workouts')">
            <b class="label" @click="open_viewer">Payment Plan</b>
          </v-tab>
          <v-tab 
            v-if="
              (item.SubCat_slug == 'intranet-network') ||
              (item.SubCat_slug == 'landline-internet') || 
              (item.SubCat_slug == 'mobile-network') ||
              (item.SubCat_slug == 'outdoor-advertising') ||
              (item.SubCat_slug == 'radio-advertising') ||
              (item.SubCat_slug == 'tv-advertising') ||
              (item.SubCat_slug == 'dance-classes') ||
              (item.SubCat_slug == 'gyms') ||
              (item.SubCat_slug == 'real-estate') ||
              (item.SubCat_slug == 'bureau-of-standards') ||
              (item.SubCat_slug == 'consumer-protection') ||
              (item.SubCat_slug == 'recruitments') ||
              (item.SubCat_slug == 'banks') ||
              (item.SubCat_slug == 'taxation-bills') || 
              (item.SubCat_slug == 'electricity-bills') ||
              (item.SubCat_slug == 'insurance') ||
              (item.SubCat_slug == 'micro-finance-loans') ||
              (item.SubCat_slug == 'tv-pay') ||
              (item.SubCat_slug == 'water-bills') ||
              (item.SubCat_slug == 'art-print-design') ||
              (item.SubCat_slug == 'computer-telecom') || 
              (item.SubCat_slug == 'legal-aid-advocates') ||
              (item.SubCat_slug == 'security-protection') ||
              (item.SubCat_slug == 'sports-clubs')">
            <b class="label" @click="open_viewer">Specials</b>
          </v-tab>
          <v-tab  
            v-if="
              (item.SubCat_slug == 'banks') ||
              (item.SubCat_slug == 'cinemas') || 
              (item.SubCat_slug == 'bureau-de-change')">
            <b class="label" @click="open_viewer">Shows</b>
          </v-tab>
          <v-tab  
            v-if="
              (item.SubCat_slug == 'art-print-design') ||
              (item.SubCat_slug == 'computer-telecom') ||
              (item.SubCat_slug == 'metal-plastic-wood')">
            <b class="label" @click="open_viewer">Training</b>
          </v-tab>
          <v-tab  
            v-if="
              (item.SubCat_slug == 'airline-flight') ||
              (item.SubCat_slug == 'bus-railway') || 
              (item.SubCat_slug == 'taxi') ||
              (item.SubCat_slug == 'warehouse-container-storage') ||
              (item.SubCat_slug == 'garbage-collection')">
            <b class="label" @click="open_viewer">Transport</b>
          </v-tab>
          <v-tab 
            v-if="
              (item.SubCat_slug == 'dance-classes') ||
              (item.SubCat_slug == 'game-reserves') ||
              (item.SubCat_slug == 'sports-clubs')">
            <b class="label" @click="open_viewer">Rewards</b>
          </v-tab>
          <v-tab>
            <b class="label" @click="open_viewer">Related Services</b>
          </v-tab>
          <v-tab>
            <b class="label" @click="open_viewer">Comments(10)</b>
          </v-tab>
          <v-tab>
            <b class="label" @click="open_viewer">About us</b>
          </v-tab>
          <v-tab-item 
            v-if="
              (item.SubCat_slug == 'hotels') ||
              (item.SubCat_slug == 'lodges') ||
              (item.SubCat_slug == 'buffets') ||
              (item.SubCat_slug == 'restaurants') ||
              (item.SubCat_slug == 'take-aways') ||
              (item.SubCat_slug == 'guest-houses-cottages')">
            <v-container fluid fill-height>
              <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
              <v-card>
                <v-toolbar dark color="primary">
                  <v-toolbar-title>Meals</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="dialog = false"><b>Close</b></v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <div class="container">
                  <div class="columns" style="padding-bottom: 0px; margin-bottom: 0px;">
                    <div class="column is-4">
                      <div class="columns is-multiline">
                        <div class="column is-12">
                          <img src="http://via.placeholder.com/620x620" alt="service name">
                        </div>
                        <div class="column is-4">
                          <img src="http://via.placeholder.com/620x620" alt="service name">
                        </div>
                        <div class="column is-4">
                          <img src="http://via.placeholder.com/620x620" alt="service name">
                        </div>
                        <div class="column is-4">
                          <img src="http://via.placeholder.com/620x620" alt="service name">
                        </div>
                      </div>
                    </div>
                    <div class="column is-6">
                      <div>
                        <!-- Artificial Bread Crumbs -->
                          <router-link to="/">Home</router-link><v-icon>mdi-forward</v-icon>
                          <router-link :to="'/services/'+ item.Cat_slug">{{ item.Cat_slug | capitalize}}</router-link><v-icon>mdi-forward</v-icon>
                          {{  item.name | capitalize }}
      
                        <!-- Artificial Bread Crumbs: End -->
                        <h1 class="title is-4">
                          service Name
                        </h1>
                        <p>
                          Category: service Category
                        </p>
                        <p>
                          Client: Client Name
                        </p>
                        <p>
                          Availabilty: (50) InStock
                        </p>
                        <hr>
                        <span class="tag is-rounded is-medium is-dark">
                          Out of stock
                        </span>
                        <span class="tag is-rounded is-medium">
                          <v-icon left>mdi-tag mdi-24px</v-icon> K 500
                        </span>
                      </div>
                      <div>
                        <form action="" @submit.prevent="add">
                          <div class="field">
                            <label class="label">
                              Type
                            </label>
                            <div class="control">
                              
                                <!--<div class="select is-one-third"> <select :value="selectedVariationId">
                                  <option value="">Please choose</option>
                                  <option>
                                    Variation Name

                                    <template>
                                      <v-icon left>mdi-tag mdi-24px</v-icon> K 500
                                    </template>

                                    <template>
                                      (out of stock)
                                    </template>
                                  </option>
                                </select> </div>-->
                                <!-- <v-select
                                  :items="items"
                                  label="Standard"
                                ></v-select> -->
                              
                            </div>
                          </div>

                          <div class="field has-addons">
                            <div class="control">
                              <div class="select is-fullwidth">
                                <select name="" id="">
                                  <option>
                                    Qty
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="control">
                              <button type="submit" class="button is-info">Add to cart</button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="column is-2">
                      <div class="label">Share:</div>
                      <div><img src="@/assets/googleicon.png" alt="Google" width="30" /> | <img src="@/assets/facebook.jpg" alt="Facebook" width="30" /> | <img src="@/assets/twitter.jpg" alt="Twitter" width="30" /></div>
                      <!-- <div>WhatsApp</div> -->
                    </div>
                  </div>
                  <v-tabs grow>
                    <v-tab><b class="label">Description</b></v-tab>
                    <v-tab><b class="label">Specification</b></v-tab>
                    <v-tab><b class="label">Reviews(5)</b></v-tab>
                    <v-tab><b class="label">Related services</b></v-tab>
                    <v-tab-item>
                      <b><p>Beryl Cook is one of Britain’s most talented and amusing artists .Beryl’s pictures feature women of all shapes and sizes enjoying themselves .Born between the two world wars, Beryl Cook eventually left Kendrick School in Reading at the age of 15, where she went to secretarial school and then into an insurance office. After moving to London and then Hampton, she eventually married her next door neighbour from Reading, John Cook. He was an officer in the Merchant Navy and after he left the sea in 1956, they bought a pub for a year before John took a job in Southern Rhodesia with a motor company. Beryl bought their young son a box of watercolours, and when showing him how to use it, she decided that she herself quite enjoyed painting. John subsequently bought her a child’s painting set for her birthday and it was with this that she produced her first significant work, a half-length portrait of a dark-skinned lady with a vacant expression and large drooping breasts. It was aptly named ‘Hangover’ by Beryl’s husband and still hangs in their house today</p>
                      <p>It is often frustrating to attempt to plan meals that are designed for one. Despite this fact, we are seeing more and more recipe books and Internet websites that are dedicated to the act of cooking for one. Divorce and the death of spouses or grown children leaving for college are all reasons that someone accustomed to cooking for more than one would suddenly need to learn how to adjust all the cooking practices utilized before into a streamlined plan of cooking that is more efficient for one person creating less waste. The mission</p></b>
                    </v-tab-item>
                    <v-tab-item>
                      <v-simple-table fixed-header height="300px">
                        <tbody>
                          <tr>
                            <td><i class="label">Width:</i></td>
                            <td><b class="label">128mm</b></td>
                          </tr>
                          <tr>
                            <td><i class="label">Height:</i></td>
                            <td><b class="label">508mm</b></td>
                          </tr>
                          <tr>
                            <td><i class="label">Depth:</i></td>
                            <td><b class="label">85mm</b></td>
                          </tr>
                          <tr>
                            <td><i class="label">Weight:</i></td>
                            <td><b class="label">52gm</b></td>
                          </tr>
                          <tr>
                            <td><i class="label">Quality checking:</i></td>
                            <td><b class="label">Yes</b></td>
                          </tr>
                          <tr>
                            <td><i class="label">Freshness Duration:</i></td>
                            <td><b class="label">03days</b></td>
                          </tr>
                          <tr>
                            <td><i class="label">When packeting:</i></td>
                            <td><b class="label">Without touch of hand</b></td>
                          </tr>
                          <tr>
                            <td><i class="label">Each Box contains:</i></td>
                            <td><b class="label">60pcs</b></td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-tab-item>
                    <v-tab-item>
                      <div class="columns">
                        <div class="column is-7">
                          <p>Blake Ruiz</p>
                          <p>12th Feb, 2017 at 05:56 pm</p>
                          <p>Reply|<b>Rating (read-only)</b></p>
                          <b>Acres of Diamonds… you’ve read the famous story, or at least had it related to you. A farmer hears tales of diamonds and begins dreaming of vast riches. He sells his farm and hikes off over the horizon, never to be heard from again.</b><!--Pagination | Infinite Scroll -->
                        </div>
                        <div class="column is-5">
                          <v-form ref="form" v-model="valid" lazy-validation>
                            <v-text-field v-model="name" :counter="10" :rules="nameRules" label="Your Name" required></v-text-field>
                            <v-text-field v-model="email" :rules="emailRules" label="Your E-mail" required></v-text-field>
                            <b>Place your service rating<v-rating v-model="rating" color="yellow darken-3" background-color="grey darken-1" empty-icon="$vuetify.icons.ratingFull" hover></v-rating></b>
                            <v-textarea append-icon="mdi-message-reply-text" label="Your Review" class="mx-2"></v-textarea>
                            <v-btn :disabled="!valid" color="success" class="mr-4">
                            Add Review</v-btn>
                          </v-form>
                        </div>
                      </div>
                    </v-tab-item>
                    <v-tab-item>
                      <servicecarousel />
                    </v-tab-item>
                  </v-tabs>
                </div>
              </v-card>
              <template v-slot:activator="{ on }">
              <v-layout>
                <div class="columns is-multiline">
                  <div class="column is-3">
                    <v-flex xs12>
                      <div class="label title is-3">Filters :</div>
                      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search services" single-line hide-details></v-text-field>
                      <v-select :items="cuisines" label="By Cuisines"></v-select>
                      <v-range-slider v-model="slider" label="Price" thumb-label></v-range-slider>
                      <v-switch v-model="tick" label="Show Only Special Dishes" color="indigo darken-3" value="" hide-details></v-switch>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-6"><v-img height="230" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png" class="black--text"  v-on="on">
                          <v-card-title class="left">Price 1</v-card-title>
                        </v-img>
                          <v-card-text>
                            <v-layout align-center>
                              <v-rating :value="4.5" color="amber" half-increments dense size="14" readonly></v-rating>
                              <div class="grey--text ml-4">4.5 (413)</div>
                            </v-layout>
                            <div style="margin-top: 0px; padding-top: 0px;"> 
                              <v-card-title>Meal 1 | <add-to-cart /></v-card-title>
                            </div>
                          </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-6"><v-img height="230" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png" class="black--text"  v-on="on">
                          <v-card-title class="left">Price 1</v-card-title>
                        </v-img>
                          <v-card-text>
                            <v-layout align-center>
                              <v-rating :value="4.5" color="amber" half-increments dense size="14" readonly></v-rating>
                              <div class="grey--text ml-4">4.5 (413)</div>
                            </v-layout>
                            <div style="margin-top: 0px; padding-top: 0px;"> 
                              <v-card-title>Meal 1 | <add-to-cart /></v-card-title>
                            </div>
                          </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-6"><v-img height="230" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png" class="black--text"  v-on="on">
                          <v-card-title class="left">Price 1</v-card-title>
                        </v-img>
                          <v-card-text>
                            <v-layout align-center>
                              <v-rating :value="4.5" color="amber" half-increments dense size="14" readonly></v-rating>
                              <div class="grey--text ml-4">4.5 (413)</div>
                            </v-layout>
                            <div style="margin-top: 0px; padding-top: 0px;"> 
                              <v-card-title>Meal 1 | <add-to-cart /></v-card-title>
                            </div>
                          </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-6"><v-img height="230" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png" class="black--text"  v-on="on">
                          <v-card-title class="left">Price 1</v-card-title>
                        </v-img>
                          <v-card-text>
                            <v-layout align-center>
                              <v-rating :value="4.5" color="amber" half-increments dense size="14" readonly></v-rating>
                              <div class="grey--text ml-4">4.5 (413)</div>
                            </v-layout>
                            <div style="margin-top: 0px; padding-top: 0px;"> 
                              <v-card-title>Meal 1 | <add-to-cart /></v-card-title>
                            </div>
                          </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                </div>
              </v-layout>
            </template>
            </v-dialog>
            </v-container>
          </v-tab-item>
          <v-tab-item 
            v-if="
              (item.SubCat_slug == 'apartments') || 
              (item.SubCat_slug == 'rental-houses-facilities') || 
              (item.SubCat_slug == 'boarding-houses-hostels')">
            <div class="container">
              <div class="columns">
                <div class="column is-3" v-for="room in filteredRoomViewService" :key="room.id">
                  <v-card class="elevation-4">
                    <v-img height="160" :src="getImage(room.view_images)"  responsive :lazy-src="getImage(room.view_images)" class="white--text">
                      <v-card-title style="word-break: normal">
                        <b>{{ room.view_name }}</b>
                      </v-card-title>
                    </v-img>
                    <v-card-text class="subtitle-1 black--text">
                      <span class="label">
                        {{ room.view_desc }}
                      </span>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item 
            v-if="
              (item.SubCat_slug == 'hotels') ||
              (item.SubCat_slug == 'dance-classes') ||
              (item.SubCat_slug == 'gyms') ||
              (item.SubCat_slug == 'massage-spa-treatments') ||
              (item.SubCat_slug == 'sports-clubs') ||
              (item.SubCat_slug == 'fabric-furniture-repair') ||
              (item.SubCat_slug == 'home-office-construction') ||
              (item.SubCat_slug == 'light-water-repair') ||
              (item.SubCat_slug == 'bureau-of-standards') ||
              (item.SubCat_slug == 'consumer-protection') ||
              (item.SubCat_slug == 'recruitments') ||
              (item.SubCat_slug == 'banks') ||
              (item.SubCat_slug == 'car-fabrics-locomotive-washing') ||
              (item.SubCat_slug == 'dental-dermatology') || 
              (item.SubCat_slug == 'fertility-sonar-pediatrics') ||
              (item.SubCat_slug == 'garbage-collection') ||
              (item.SubCat_slug == 'indoor-window-interior-cleaning') ||
              (item.SubCat_slug == 'pests-rodent-reptile-clearing') ||
              (item.SubCat_slug == 'radiology-xrays') ||
              (item.SubCat_slug == 'vet-clinic') ||
              (item.SubCat_slug == 'taxation-bills') || 
              (item.SubCat_slug == 'bureau-de-change') ||
              (item.SubCat_slug == 'electricity-bills') ||
              (item.SubCat_slug == 'insurance') ||
              (item.SubCat_slug == 'micro-finance-loans') ||
              (item.SubCat_slug == 'tv-pay') ||
              (item.SubCat_slug == 'water-bills') ||
              (item.SubCat_slug == 'security-protection') ||
              (item.SubCat_slug == 'mechanical-repair') ||
              (item.SubCat_slug == 'adventure-spots-camps') || 
              (item.SubCat_slug == 'casinos') ||
              (item.SubCat_slug == 'family-parks') ||
              (item.SubCat_slug == 'game-reserves') ||
              (item.SubCat_slug == 'night-clubs-bars') ||
              (item.SubCat_slug == 'adventure-spots-camps') ||
              (item.SubCat_slug == 'art-print-design') ||
              (item.SubCat_slug == 'computer-telecom') || 
              (item.SubCat_slug == 'legal-aid-advocates') ||
              (item.SubCat_slug == 'metal-plastic-wood') ||
              (item.SubCat_slug == 'intranet-network') ||
              (item.SubCat_slug == 'landline-internet') || 
              (item.SubCat_slug == 'mobile-network') ||
              (item.SubCat_slug == 'events-hosting-venues') || 
              (item.SubCat_slug == 'morgue-send-off-planners') ||
              (item.SubCat_slug == 'flowers-decoration') ||
              (item.SubCat_slug == 'wedding-birthday-party-planners') ||
              (item.SubCat_slug == 'yoga-workouts')">
            <v-container fluid fill-height>
              This Shows the Activities Occurring 
            </v-container>
          </v-tab-item>
          <v-tab-item 
            v-if="
              (item.SubCat_slug == 'gyms') ||
              (item.SubCat_slug == 'hotels') ||
              (item.SubCat_slug == 'car-fabrics-locomotive-washing') ||
              (item.SubCat_slug == 'dental-dermatology') || 
              (item.SubCat_slug == 'fertility-sonar-pediatrics') ||
              (item.SubCat_slug == 'events-hosting-venues') || 
              (item.SubCat_slug == 'morgue-send-off-planners') ||
              (item.SubCat_slug == 'flowers-decoration') ||
              (item.SubCat_slug == 'wedding-birthday-party-planners') ||
              (item.SubCat_slug == 'garbage-collection') ||
              (item.SubCat_slug == 'indoor-window-interior-cleaning') ||
              (item.SubCat_slug == 'pests-rodent-reptile-clearing') ||
              (item.SubCat_slug == 'radiology-xrays') ||
              (item.SubCat_slug == 'vet-clinic') ||
              (item.SubCat_slug == 'game-reserves') ||
              (item.SubCat_slug == 'art-print-design') || 
              (item.SubCat_slug == 'metal-plastic-wood') ||
              (item.SubCat_slug == 'heritage-archives') ||
              (item.SubCat_slug == 'lodges')">
            <v-container fluid fill-height>
              This Shows the Items of The Service.
            </v-container>
          </v-tab-item>
          <v-tab-item 
            v-if="
              (item.SubCat_slug == 'hotels') ||
              (item.SubCat_slug == 'lodges') ||
              (item.SubCat_slug == 'guest-houses-cottages')">
            <v-container fluid fill-height>
              This Shows the Rooms and Each Rooms Details and Price. 
            </v-container>
          </v-tab-item>
          <v-tab-item 
            v-if="
              (item.SubCat_slug == 'hotels') ||
              (item.SubCat_slug == 'night-clubs-bars') ||
              (item.SubCat_slug == 'guest-houses-cottages') ||
              (item.SubCat_slug == 'lodges')">
            <v-container fluid fill-height>
              This Shows the Types of Drinks and Beverages Offered. 
            </v-container>
          </v-tab-item>
          <v-tab-item 
            v-if="
              (item.SubCat_slug == 'cinemas') ||
              (item.SubCat_slug == 'airline-flight') ||
              (item.SubCat_slug == 'bus-railway') || 
              (item.SubCat_slug == 'cargo-freight') ||
              (item.SubCat_slug == 'taxi') ||
              (item.SubCat_slug == 'warehouse-container-storage') ||
              (item.SubCat_slug == 'hotels')">
            <v-container fluid fill-height>
              This Shows the Extra Facilities. 
            </v-container>
          </v-tab-item>
          <v-tab-item 
            v-if="
              (item.SubCat_slug == 'hotels') ||
              (item.SubCat_slug == 'lodges')">
            <v-container fluid fill-height>
              This Shows the Gym. 
            </v-container>
          </v-tab-item>
          <v-tab-item 
            v-if="
              (item.SubCat_slug == 'dental-dermatology') ||
              (item.SubCat_slug == 'fertility-sonar-pediatrics') ||
              (item.SubCat_slug == 'radiology-xrays') ||
              (item.SubCat_slug == 'vet-clinic')">
            <v-container fluid fill-height>
              This Shows the Health Procedures. 
            </v-container>
          </v-tab-item>
          <v-tab-item 
            v-if="
              (item.SubCat_slug == 'airline-flight') ||
              (item.SubCat_slug == 'bus-railway') || 
              (item.SubCat_slug == 'cargo-freight') ||
              (item.SubCat_slug == 'taxi') ||
              (item.SubCat_slug == 'warehouse-container-storage') ||
              (item.SubCat_slug == 'adventure-spots-camps')">
            <v-container fluid fill-height>
              This Shows the Maximum Capacity. 
            </v-container>
          </v-tab-item>
          <v-tab-item 
            v-if="
              (item.SubCat_slug == 'dance-classes') ||
              (item.SubCat_slug == 'gyms') ||
              (item.SubCat_slug == 'massage-spa-treatments') ||
              (item.SubCat_slug == 'sports-clubs') ||
              (item.SubCat_slug == 'bureau-of-standards') ||
              (item.SubCat_slug == 'consumer-protection') ||
              (item.SubCat_slug == 'banks') ||
              (item.SubCat_slug == 'taxation-bills') || 
              (item.SubCat_slug == 'electricity-bills') ||
              (item.SubCat_slug == 'insurance') ||
              (item.SubCat_slug == 'micro-finance-loans') ||
              (item.SubCat_slug == 'tv-pay') ||
              (item.SubCat_slug == 'water-bills') ||
              (item.SubCat_slug == 'recruitments') ||
              (item.SubCat_slug == 'car-fabrics-locomotive-washing') ||
              (item.SubCat_slug == 'garbage-collection') ||
              (item.SubCat_slug == 'indoor-window-interior-cleaning') ||
              (item.SubCat_slug == 'pests-rodent-reptile-clearing') ||
              (item.SubCat_slug == 'buffets') ||
              (item.SubCat_slug == 'events-hosting-venues') || 
              (item.SubCat_slug == 'morgue-send-off-planners') ||
              (item.SubCat_slug == 'flowers-decoration') ||
              (item.SubCat_slug == 'wedding-birthday-party-planners') ||
              (item.SubCat_slug == 'security-protection') ||
              (item.SubCat_slug == 'real-estate') ||
              (item.SubCat_slug == 'intranet-network') ||
              (item.SubCat_slug == 'landline-internet') || 
              (item.SubCat_slug == 'mobile-network') ||
              (item.SubCat_slug == 'outdoor-advertising') ||
              (item.SubCat_slug == 'radio-advertising') ||
              (item.SubCat_slug == 'tv-advertising') ||
              (item.SubCat_slug == 'yoga-workouts')">
            <v-container fluid fill-height>
              This Shows the Payment Plan. 
            </v-container>
          </v-tab-item>
          <v-tab-item 
            v-if="
              (item.SubCat_slug == 'intranet-network') ||
              (item.SubCat_slug == 'landline-internet') || 
              (item.SubCat_slug == 'mobile-network') ||
              (item.SubCat_slug == 'outdoor-advertising') ||
              (item.SubCat_slug == 'radio-advertising') ||
              (item.SubCat_slug == 'tv-advertising') ||
              (item.SubCat_slug == 'dance-classes') ||
              (item.SubCat_slug == 'gyms') ||
              (item.SubCat_slug == 'real-estate') ||
              (item.SubCat_slug == 'bureau-of-standards') ||
              (item.SubCat_slug == 'consumer-protection') ||
              (item.SubCat_slug == 'recruitments') ||
              (item.SubCat_slug == 'banks') ||
              (item.SubCat_slug == 'taxation-bills') || 
              (item.SubCat_slug == 'electricity-bills') ||
              (item.SubCat_slug == 'insurance') ||
              (item.SubCat_slug == 'micro-finance-loans') ||
              (item.SubCat_slug == 'tv-pay') ||
              (item.SubCat_slug == 'water-bills') ||
              (item.SubCat_slug == 'art-print-design') ||
              (item.SubCat_slug == 'computer-telecom') || 
              (item.SubCat_slug == 'legal-aid-advocates') ||
              (item.SubCat_slug == 'security-protection') ||
              (item.SubCat_slug == 'sports-clubs')">
            <v-container fluid fill-height>
              This Shows the Specials of that particular service. 
            </v-container>
          </v-tab-item>
          <v-tab-item  
            v-if="
              (item.SubCat_slug == 'banks') ||
              (item.SubCat_slug == 'cinemas') || 
              (item.SubCat_slug == 'bureau-de-change')">
            <v-container fluid fill-height>
              This Shows the Movies Shows & Daily Changes To Multiple Services. 
            </v-container>
          </v-tab-item>
          <v-tab-item  
            v-if="
              (item.SubCat_slug == 'art-print-design') ||
              (item.SubCat_slug == 'computer-telecom') ||
              (item.SubCat_slug == 'metal-plastic-wood')">
            <v-container fluid fill-height>
              This Shows the Training Sessions and Tutorials. 
            </v-container>
          </v-tab-item>
          <v-tab-item  
            v-if="
              (item.SubCat_slug == 'airline-flight') ||
              (item.SubCat_slug == 'bus-railway') || 
              (item.SubCat_slug == 'taxi') ||
              (item.SubCat_slug == 'warehouse-container-storage') ||
              (item.SubCat_slug == 'garbage-collection')">
            <v-container fluid fill-height>
              This Shows the Transport and Trips. 
            </v-container>
          </v-tab-item>
          <v-tab-item 
            v-if="
              (item.SubCat_slug == 'dance-classes') ||
              (item.SubCat_slug == 'game-reserves') ||
              (item.SubCat_slug == 'sports-clubs')">
            <v-container fluid fill-height>
              This Shows the Rewards and Price For Particular Services. 
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid fill-height>
              This Shows the Service Related To the Initial Service Within the Same Stream. 
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid fill-height>
              This Shows the Comments On the Service and We be Pushed closer to the Intro. 
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid fill-height>
              The upper of the about us shows the contact inform for the event
              <b>This gives the about us of the company and can be activated by the client.</b>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-content>
      <generalfab />
    </v-app>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {fb,db} from '@/firebase'
  import { mapState, mapGetters, mapActions } from 'vuex'
  import SocialSharing from 'vue-social-sharing'
  Vue.use(SocialSharing)
  import mapdirection from '@/components/Client/map.vue'

	export default {
    name: 'service',
    data: () => ({
      uid: null,
      item: null,
      extendy: true,
      nav_title: 'Service Page',
      user: null,
      comments: {
        service_id: '',
        service_slug: '',
        service_comment: '',
        user_id: '',
        client_id: '',
        user_name: ''
      },
      commento: [],
      ratingo: [],
      ratings: {
        service_id: '',
        service_slug: '',
        service_rating: '',
        user_id: ''
      },
      quantityNumber: 0,
      quantityValue: null,
      dialog: false,
      dialog1: false,
      sheet: false,
      sheet1: false,
      index: null,
      cuisines : [
        'All',
        'Indian',
        'Chinese',
        'African',
        'Italian',
        'Indian'
      ]
    }),

    mounted() {
      this.initServico(this.$route.params.slug)
    },

    methods: {
      getImage(view_images){
        return view_images[0]
      },

      open_viewer(){
        this.extendy = false
      },
      
      close_viewer(){
        this.extendy = true
      },

      ...mapActions('subServicesModule', 
        [ 
          'initServico', 
          'initAvaiActSubServices',
          'initAvaItemSubServices',
          'initAvaiRoomSubServices',
          'initDrinkSubServices',
          'initExtrafacSubServices',
          'initGymFacSubServices',
          'initHealthSubServices',
          'initInhouseSubServices',
          'initMaxCapSubServices',
          'initRestMealServices',
          'initPayPlanSubServices',
          'initRewPriceSubServices',
          'initRoomViewSubServices',
          'initSpecialSubServices',
          'initStarShowsSubServices',
          'initTrainingSubServices',
          'initTransTripSubServices'
        ]
      ),

      back(){
        this.$router.go(-1)
      },
      getFirstImage(carousel_images){
        return carousel_images[0]
      },
      getSecondImage(carousel_images){
        return carousel_images[1]
      },
      getThirdImage(carousel_images){
        return carousel_images[2]
      },
      getFourthImage(carousel_images){
        return carousel_images[3]
      },
      getFifthImage(carousel_images){
        return carousel_images[4]
      },
      addNew(){
        this.reset()
        this.dialog = true
      },
      ratingSum(){
        return this.ratingo.reduce((prev,cur) => prev + cur.service_rating,0)
      },
      reset(){
        this.ratings = {
          service_id: '',
          service_slug: '',
          service_rating: '',
          user_id: ''
        }
        this.comments = {
          service_id: '',
          service_slug: '',
          service_comment: '',
          client_slug: '',
          user_name: '',
          user_id: ''
        }  
      },
      addQuantity(){
        if (this.quantityNumber>=0 && this.quantityNumber<= this.item.quantity-2){
            this.quantityNumber++
        }
      },
      subtractQuantity(){
          if (this.quantityNumber>0){
              this.quantityNumber--
          }
      },
      addToServiceCart(){
        this.quantityValue = this.quantityNumber
        this.total = ((this.quantityValue)*(this.item.price))
        // db.collection('services').doc(this.item.id).update({
        //     quantity: ((this.item.quantity)-(this.quantityValue))
        // })
        // USE THIS IN THE CHECKOUT INSTEAD
        db.collection('cartitems').add({
            service_name: this.item.name,
            service_image: this.item.image,
            service_price: this.item.price,
            client_name: this.item.client,
            client_town: this.item.town_code,
            service_quantity: this.quantityValue,
            service_total: this.total,
            service_id: this.item.id,
            user: this.uid
        }).then(() => {
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'service added to cart'
        })
        }).catch(err => {
            console.log(err);
        })
        /* eslint-enable */
      },
      addToWishlist(){
        db.collection('wishlists').add({
            service_name: this.item.name,
            service_slug: this.item.slug,
            service_image: this.item.image,
            client_name: this.item.client,
            client_town: this.item.town_code,
            service_id: this.item.id,
            user: this.uid
        }).then(() => {
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'service added to wishlist'
        })
        }).catch(err => {
            console.log(err);
        })
        /* eslint-enable */
      },
      addServiceComments(){
        db.collection('comments').add({
            service_id: this.item.id,
            service_slug: this.item.slug,
            client_slug: this.item.client,
            user_name: this.user.name,
            service_comment: this.comments.service_comment,
            user: this.uid
        }).then(() => {
        /* eslint-disable */
          Toast.fire({
            type: 'success',
            title: 'Review Successful!'
          })
          this.close()
        }).catch(err => {
          console.log(err);
        })
        /* eslint-enable */
      },
      addServiceRating(){
        db.collection('ratings').add({
          service_id: this.item.id,
          service_slug: this.item.slug,
          service_rating: this.ratings.service_rating,
          user: this.uid
        }).then(() => {
        /* eslint-disable */
          Toast.fire({
            type: 'success',
            title: 'Review Successful!'
          })
          this.close()
        }).catch(err => {
          /* eslint-disable */
          console.log(err);
          /* eslint-enable */
        }) 
      },

      updateServiceRating(){
        db.collection('ratings').doc(this.item.id).update({
          quantity: ((this.item.quantity)-(this.quantityValue))
        })
      },
      close () {
        this.dialog = false
      }
    },

    components: {
      mapdirection
    },

    created(){
      this.uid = fb.auth().currentUser.uid

      //get item data 
      let ref = db.collection('services')
      .where('slug', '==', this.$route.params.slug)
      ref.get().then(snapshot => {
        snapshot.forEach(doc => {
          this.item = doc.data()
          this.item.id = doc.id
        })
      })

      db.collection('comments')
      .where('service_slug','==',this.$route.params.slug).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let comment = doc.data()
          comment.id =  doc.id
          this.commento.push(comment) 
        })
      })

      db.collection('ratings')
      .where('service_slug','==',this.$route.params.slug).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let rating = doc.data()
          rating.id =  doc.id
          this.ratingo.push(rating) 
        })
      })

      //get current user
      db.collection('user')
      .where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.user =doc.data(),
          this.user.id = doc.id//
        })
      })
    },

    computed: {
      ...mapState('subServicesModule', 
        [
        // 'subservices_avaiact',
        // 'subservices_avaitem',
        // 'subservices_avairoom',
        // 'subservices_drink',
        // 'subservices_extrafac',
        // 'subservices_gymfac',
        // 'subservices_health',
        // 'subservices_inhouse',
        // 'subservices_maxcap',
        // 'subservices_restmeal',
        // 'subservices_payplan',
        // 'subservices_rewprice',
        'subservices_roomview'
        // 'subservices_special',
        // 'subservices_starshows',
        // 'subservices_training',
        // 'subservices_transtrips'
      ]),

      filteredRoomViewService() {
        if (this.search) {
          const regexp = new RegExp(this.search, 'gi')
          return this.subservices_roomview.filter(subservice_view =>
            (subservice_view.view_name + subservice_view.view_slug).match(regexp))
        }
        return this.subservices_roomview
      },

      ...mapGetters({
        serv: 'subServicesModule/serv'
      }),

      formTitle () {
        return this.editedIndex == -1 ? 'New Item' : 'Edit Item'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      '$route.params.slug': () => {
        this.initServico(this.$route.params.slug)
      },
      serv() {
        if (this.serv.id) {
          // this.initAvaiActSubServices(this.serv.id)
          // this.initAvaItemSubServices(this.serv.id)
          // this.initAvaiRoomSubServices(this.serv.id)
          // this.initDrinkSubServices(this.serv.id)
          // this.initExtrafacSubServices(this.serv.id)
          // this.initGymFacSubServices(this.serv.id)
          // this.initHealthSubServices(this.serv.id)
          // this.initInhouseSubServices(this.serv.id)
          // this.initMaxCapSubServices(this.serv.id)
          // this.initRestMealServices(this.serv.id)
          // this.initPayPlanSubServices(this.serv.id)
          // this.initRewPriceSubServices(this.serv.id)
          this.initRoomViewSubServices(this.serv.id)
          // this.initSpecialSubServices(this.serv.id)
          // this.initStarShowsSubServices(this.serv.id)
          // this.initTrainingSubServices(this.serv.id)
          // this.initTransTripSubServices(this.serv.id)
        }
      }
    }
  }
</script>

<style scoped>
  .mapit {
    position: absolute;
    bottom: 300px;
    right: 5%;
    pointer-events: auto;
  }
  .type {
    position: absolute;
    bottom: 250px;
    right: 70px;
  }
  .date {
    position: absolute;
    bottom: 220px;
    right: 70px;
  }
  .time {
    position: absolute;
    bottom:200px;
    right: 70px;
  }
  .crumb {
    position: absolute;
    top: -5px;
    left: 25px;
    font-size: 25px 
  }
  .main-title {
    position: absolute;
    bottom: 90px;
    left: -15px;
  }
  .title {
    position: absolute;
    bottom: 20px;
    left: -15px;
  }
  .main-title-text {
    font-size: 35px;
  }
  .title-text {
    font-size: 25px;
  }
  .left {
    float: right;
  }
</style>

<style scoped>
  .mapit-mobile {
    position: absolute;
    top: 2px;
    right: 2px;
    z-index: +5;
    pointer-events: auto;
  }
  .type-mobile {
    position: absolute;
    bottom: 120px;
    right: 2px;
  }
  .date-mobile {
    position: absolute;
    bottom: 100px;
    right: 2px;
  }
  .time-mobile {
    position: absolute;
    bottom: 80px;
    right: 2px;
  }
  .main-title-mobile {
    position: absolute;
    top: -20px;
    left: -40px;
  }
  .title-mobile {
    position: absolute;
    top: 1px;
    left: -40px;
  }
  .crumb-mobile {
    position: absolute;
    top: 20px;
    font-size: 17px;
  }
  .main-title-text-mobile {
    font-size: 25px;
  }
  .title-text-mobile {
    font-size: 20px;
  }
  .left {
    float: right;
  }
</style>
